import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { Button } from './ui';

const ViolationWarning = ({ violation, violationCount, onDismiss }) => {
  const { t } = useTranslation();
  if (!violation) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-red-900 bg-opacity-90">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full mx-4 border-4 border-red-500 text-center">
        {/* Warning Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center">
            <AlertTriangle className="w-12 h-12 text-red-600" />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-2xl font-bold text-red-600 mb-2">
          {t('violationWarning.title')}
        </h2>

        {/* Violation Count */}
        <div className="mb-4">
          <span className="inline-block bg-red-100 text-red-800 text-sm font-semibold px-3 py-1 rounded-full">
            {t('violationWarning.violationNumber', { count: violationCount })}
          </span>
        </div>

        {/* Message */}
        <p className="text-gray-700 text-base mb-2 font-medium">
          {violation.description || t('violationWarning.defaultDescription')}
        </p>
        <p className="text-gray-500 text-sm mb-6">
          {t('violationWarning.recordedNote')}
        </p>

        {/* Warning Level */}
        {violationCount >= 3 && (
          <div className="flex items-start gap-2 bg-red-50 border border-red-200 rounded-lg p-3 mb-4 text-left">
            <AlertTriangle className="w-4 h-4 text-red-600 flex-shrink-0 mt-0.5" />
            <p className="text-red-700 text-sm font-semibold">
              {t('violationWarning.finalWarning')}
            </p>
          </div>
        )}

        {/* Dismiss Button */}
        <Button variant="primary" fullWidth size="lg" onClick={onDismiss}>
          {t('violationWarning.dismiss')}
        </Button>
      </div>
    </div>
  );
};

export default ViolationWarning;
